import React, { useEffect, useState } from 'react';
var sizeType = {
    Sneakers: ['4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5', '8', '8.5', '9', '9.5', '10', '10.5', '11', '11.5', '12', '12.5', '13'],
    Shirts: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Sweaters: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Pants: ['30', '31', '32', '33', '34', '35'],
    Costumes: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
    Shorts: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
};
var SizeButtons = function (props) {
    var sizearr = sizeType[props.Type] || [];
    var _a = useState({}), Inventory = _a[0], SetInventory = _a[1];
    useEffect(function () {
        // if (props.Type === 'Hats' || props.Type === 'Skincare' || props.Type === 'Masks') {
        //     props.setSize('S')
        // }    
    });
    var sizeSet = function (e) {
        var _a, _b;
        var name = e.target.name;
        SetInventory((_a = {},
            _a[name] = e.target.value,
            _a.Inventory = (_b = {}, _b[name] = e.target.value, _b),
            _a));
    };
    return (React.createElement("div", { className: 'sb' }, props.Type ?
        sizearr.map(function (sizes) {
            return props.Inventory[sizes] > 0 ?
                (React.createElement("div", { onClick: function () { props.setSize(sizes); }, className: 'size_but' }, sizes))
                :
                    React.createElement("div", { style: { color: 'grey' }, onClick: function () { alert('size unavailables'); }, className: 'size_but' }, sizes);
        })
        : React.createElement("div", null)));
};
export default SizeButtons;



//////////////////
// WEBPACK FOOTER
// ./src/components/sizeButtons/sizeButtons2.tsx
// module id = 1404
// module chunks = 0 1 2 3 4 5